// Impede que atualizações de carrinho em SEGUNDO PLANO abram o cart drawer sozinhas.
//
// Contexto (bug "drawer abre ao entrar no site"): no Horizon, CartAddEvent e
// CartUpdateEvent compartilham o MESMO nome de evento — `ThemeEvents.cartUpdate`
// = 'cart:update' (ver assets/events.js). O cart drawer, com o setting
// `auto_open_cart_drawer` ligado, escuta 'cart:update' e abre em QUALQUER um
// (assets/cart-drawer.js -> #handleCartAdd -> showDialog).
//
// Nossos scripts conso disparam 'cart:update' pra re-renderizar a sacola após
// mexer no carrinho por conta própria (brinde automático na carga da página,
// embalagem-presente, sync da meta do brinde). Como o evento é indistinguível
// de um add real, o drawer abria sozinho ao carregar o site.
//
// Solução: os dispatchers conso marcam `window.__consoSilentCartUpdate` durante
// o dispatch (que é SÍNCRONO — todos os listeners rodam antes de voltar). Aqui
// envolvemos o showDialog do cart drawer pra ignorar a abertura enquanto essa
// flag estiver ativa. A re-renderização da sacola (component-cart-items) e o
// add-to-cart real (product-form -> CartAddEvent, sem a flag) seguem normais.

(function () {
  var GUARD_FLAG = '__consoAutoOpenGuarded';

  function wrap(CartDrawer) {
    if (!CartDrawer || CartDrawer.prototype[GUARD_FLAG]) return;
    CartDrawer.prototype[GUARD_FLAG] = true;

    var original = CartDrawer.prototype.showDialog; // herdado de DialogComponent
    if (typeof original !== 'function') return;

    CartDrawer.prototype.showDialog = function () {
      if (window.__consoSilentCartUpdate) return;
      return original.apply(this, arguments);
    };
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer-component').then(function () {
      wrap(customElements.get('cart-drawer-component'));
    });
  }
})();
